import ChartApiEconomia from '../../../pages/economia/economia-v2/ChartApi';
import ChartV5 from '../../../pages/economia/economia-v2/ChartV5';

export const MainCP = () => {
  return (
    <div className="container-fluid">
      <div className="row" style={{ marginTop: '40px' }}>
        <div className="col-12">
          <div className="d-flex justify-content-center">
            <ChartApiEconomia piePagina={'En serie IMCE e IPEC, desde 2006 a 2019 se muestran promedios anuales y para la serie ICC, 2018 y 2019 corresponde a promedios anuales.'} />
          </div>
        </div>
      </div>
    </div>
  )
}
